import { connect } from "react-redux";
import Landscape from "../components/Landscape";
import { setLandscape } from "../actions/landscape";
import { LandscapeState } from "../types/landscape";

interface connectProps {
  landscape: LandscapeState
}

export default connect(
  (state: connectProps) => {
    return ({
      ...state.landscape
    });
  },
  (dispatch) => ({
    setLand(isLandscape: Boolean) {
      dispatch(setLandscape(isLandscape))
    }
  })
)(Landscape)